export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10341.dba3cf61.jpg";